import { createElement } from 'react';
import { useParams } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { devicesMsg, t } from '../../common/i18n';
import { categories } from '../../common/utils/categoryUtils.js';
import { RenderHtmlBlock } from '../../common/utils/htmlUtils.js';
import type { Category } from '../../common/types/category.js';

export interface ProductGridTitleCoCoProps {
  title?: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  content?: string;
}

const findCategoryByUrlPath = (urlPath?: string): Category | undefined =>
  urlPath ? Object.values(categories).find(c => c.urlPath === urlPath) : undefined;

export const ProductGridTitleCoCo = ({ title, titleTag = 'h1', content }: ProductGridTitleCoCoProps) => {
  const { category: categoryUrlParam } = useParams<{ category?: string }>();
  const category = findCategoryByUrlPath(categoryUrlParam);

  const resolvedTitle = title ?? (category ? category.displayText() : t.JJTM(devicesMsg));

  const renderTitle = () => {
    if (resolvedTitle) {
      return createElement(
        titleTag,
        { className: `ds-${titleTag} product-element-title ${dsClass.MARGIN_BOTTOM_4}` },
        resolvedTitle
      );
    }
    return null;
  };

  return (
    <div className="ea-fgrid">
      <div
        className={`ea-fgrid__item ea-fgrid__item--center ea-fgrid__item--block ea-fgrid__item--phone-6 ea-fgrid__item--tablet-12 ${dsClass.TEXT_ALIGN_CENTER}`}
      >
        {renderTitle()}
        {content && (
          <RenderHtmlBlock type="div" className="">
            {content}
          </RenderHtmlBlock>
        )}
      </div>
    </div>
  );
};
